export default "__VITE_ASSET__BNWbS7s6__"